import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=5ee98046&"
import script from "./commentList.vue?vue&type=script&lang=ts&"
export * from "./commentList.vue?vue&type=script&lang=ts&"
import style0 from "./commentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports